import { getId } from 'customer-data-objects/record/ObjectRecordAccessors';
import { List } from 'immutable';
import get from 'transmute/get';
import UILink from 'UIComponents/link/UILink';
import { Flex } from 'foundations-components/components/Flex';
import { getCrmObjectKeyFromObject, getObjectTypeId } from '../../../utils/crmObjectHelpers';
import { getRecordPageLink } from '../../../utils/links';
import AssociationAvatars from './AssociationAvatars';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const getLabel = get('label');
export const getObjectRecord = get('objectRecord');
export const getUILink = objectData => {
  const objectRecord = getObjectRecord(objectData);
  const objectTypeId = getObjectTypeId(objectRecord);
  const objectId = getId(objectRecord);
  const recordPageLink = getRecordPageLink({
    objectTypeId,
    objectId
  });
  const crmObjectKey = getCrmObjectKeyFromObject(objectRecord);
  return /*#__PURE__*/_jsx(UILink, {
    href: recordPageLink,
    children: getLabel(objectData)
  }, `${crmObjectKey}-link`);
};
export const getTooltip = associatedObject => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(AssociationAvatars, {
      associatedObjects: List([associatedObject])
    }), getUILink(associatedObject)]
  });
};